import React from 'react'
import './Criteria_details.css'
import RedRoundBtn from '../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn'
import { useNavigate } from 'react-router-dom';

function Criteria_details() {
    const navigate = useNavigate();
    return (
        <>
            <section className='Criteria_details'>
                <div className="container">
                    <p className='section_heading'>Check Your Eligibility</p>
                    <div class="text_holder">
                        <p>
                            Share your details to help us understand your requirements. Our team will review your information and guide you toward suitable financial options offered by third-party institutions.
                        </p>

                    </div>

                    <div className="btn_holder" style={{ width: "fit-content", margin: "0px auto" }}>
                        <RedRoundBtn btn_name="Check Eligibility Criteria" onClick={() => navigate("/check-eligibility-criteria")} />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Criteria_details